import { useTranslation } from 'react-i18next';
import { useParams, useSearchParams } from 'react-router';
import { useLocalStorageState, useMount } from 'ahooks';
import { Box, CircularProgress } from '@mui/material';
import { useBizState } from '@/hooks/use-biz-state';
import { getCallbackKey, useSocialLogin } from '@/hooks/use-social-login';

export const ThirdCallback = () => {
  const { thirdname } = useParams();
  const { i18n } = useTranslation();
  const { socialAuthorizing } = useBizState();
  const { doSocialLoginCallback, isOpenWindow } = useSocialLogin();
  const [socialCallbackKey, setSocialCallbackKey] = useLocalStorageState<string>('socialCallbackKey');
  const [searchParams] = useSearchParams();

  useMount(() => {
    const code = searchParams.get('code') || '';
    const state = searchParams.get('state') || '';
    const callbackKey = getCallbackKey(code, state);
    if ((socialCallbackKey !== callbackKey && isOpenWindow) || !isOpenWindow) {
      doSocialLoginCallback({
        lang: i18n.language,
        code,
        state,
        thirdName: thirdname || '',
        cb: window.location.origin + window.location.pathname,
      });
    }
    setSocialCallbackKey(callbackKey);
  });

  return !isOpenWindow && socialAuthorizing ? (
    <Box className="min-h-dvh w-full" display="flex" alignItems="center" justifyContent="center" flexDirection="column">
      <CircularProgress size={24} aria-hidden="true" role="img" />
    </Box>
  ) : null;
};
